module.exports = __webpack_public_path__ + "img/logos-mars-cinepolis-coca-cola.498316b3.png";